export default __webpack_public_path__ + "static/media/logotipo-qd-branco.c18df7e1.png";